import { render, staticRenderFns } from "./CheckersTable.vue?vue&type=template&id=64fa33de&"
import script from "./CheckersTable.vue?vue&type=script&lang=js&"
export * from "./CheckersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports